import { render, staticRenderFns } from "./compliance-create.vue?vue&type=template&id=48b99f86&"
import script from "./compliance-create.vue?vue&type=script&lang=js&"
export * from "./compliance-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports